<template>
  <div class="header-pc">
    <div class="left" @click="goHome">
      <img src="@/assets/logo@2x.png" />
      校企合作“双进双转”需求征集系统
    </div>
    <div class="right">
      <div
        class="item"
        @click="openManual"
        title="操作手册"
        style="color: red;"
      >
        <img src="@/assets/操作手册.svg" />
        操作手册
      </div>
      <div
        class="item"
        v-if="$store.state.userInfo && 'id' in $store.state.userInfo"
        @click="goPersonal"
      >
        <img src="@/assets/应用.svg" />
        用户中心
      </div>
      <div
        class="item"
        v-if="$store.state.userInfo && 'id' in $store.state.userInfo"
        @click="handleLogout"
      >
        <img src="@/assets/退出.svg" />
        注销
      </div>
      <div class="item" v-else @click="jumpLogin">
        <img src="@/assets/未登录.svg" />
        登录
      </div>
    </div>
  </div>
</template>

<script>
import { getConfigKey } from '@/api/common';

export default {
  data() {
    return {};
  },
  methods: {
    goHome() {
      this.$router.push('/home');
    },
    goPersonal() {
      this.$router.push('/personal');
    },
    openManual() {
      getConfigKey('sub.manual').then((res) => {
        const url = res.msg || res.data;
        if (url) {
          window.open(url, '_blank');
        } else {
          this.$message.error('操作手册地址获取失败');
        }
      });
    },
    jumpLogin() {
      this.$router.push('/login');
    },
    handleLogout() {
      this.$confirm('确认要注销当前账号吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$message.success('已注销');
        this.$store.dispatch('LogOut').then(() => {
          this.$router.push('/login');
        });
      });
    },
  },
};
</script>

<style lang="scss" scope>
.header-pc {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 90px;
  z-index: 99;
  background-color: #fff;
  padding: 0 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    font-family: MicrosoftYaHei-Bold;
    font-size: 24px;
    color: #333333;
    font-weight: 700;
    gap: 15px;
    cursor: pointer;
    transition: color 0.2s ease;
    &:hover {
      color: #0b86ec;
    }
    img {
      width: 44px;
    }
  }
  .right {
    display: flex;
    align-items: center;
    gap: 50px;
    .item {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #333333;
      font-weight: 400;
      cursor: pointer;
      transition: 0.2s ease;
      &:hover {
        color: #0b86ec !important;
        img {
          filter: brightness(0) saturate(100%) invert(34%) sepia(95%) saturate(1411%) hue-rotate(184deg) brightness(92%) contrast(93%);
        }
      }
      img {
        width: 14px;
        margin-right: 5px;
      }
    }
  }
}
</style>
